import React from "react";
import { inject } from "mobx-react";

@inject("ApplicationModel")
export default class OrdersHOC extends React.Component {
	componentDidMount() {
		let fixedPanelModel = this.props.ApplicationModel.fixedPanelModel;
		let compareTarifficationsModel = this.props.ApplicationModel.compareTarifficationsModel;
		fixedPanelModel.setShowGiftWidget(false);
		compareTarifficationsModel.setWidgetIsHide();
	}

	componentWillUnmount() {
		let fixedPanelModel = this.props.ApplicationModel.fixedPanelModel;
		let compareTarifficationsModel = this.props.ApplicationModel.compareTarifficationsModel;
		fixedPanelModel.setShowGiftWidget(true);
		compareTarifficationsModel.setWidgetIsVisible();
	}

	render() {
		return this.props.children;
	}
}
